import { Typography } from '@mui/material'

import { Copy, CopyContainer } from '../common/copy'
import styles from './leadLocked.module.scss'

const LeadLocked = () => {
  return (
    <div className={styles.leadLockedRoot}>
      <CopyContainer padding="xsmall" className="text-align-center">
        <Copy>
          <Typography variant="h5">RESTRICTED</Typography>
        </Copy>
      </CopyContainer>
    </div>
  )
}

export default LeadLocked
